export default __webpack_public_path__ + "static/media/check-in.d3f2da08.jpeg";